/*
 * patient-signature (zod)
 */
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { patientSignatures } from "./patient-signature.schema"

export type PatientSignature = z.infer<typeof selectPatientSignatureSchema>
export const selectPatientSignatureSchema = createSelectSchema(patientSignatures)

export type PatientSignatureFilters = z.infer<typeof patientSignatureFiltersSchema>
export const patientSignatureFiltersSchema = z.object({
	id: z.string().optional(),
	patientId: z.string().optional(),
	active: z.boolean().optional(),
})

export const createPatientSignatureSchema = createInsertSchema(patientSignatures).partial(
	globalCreateExclude,
)
export type CreatePatientSignature = z.infer<typeof createPatientSignatureSchema>

export const updatePatientSignatureSchema = createInsertSchema(patientSignatures)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdatePatientSignature = z.infer<typeof updatePatientSignatureSchema>
